import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import {
  useApiOrdersSwrGetMiraklOrders,
  userSubOrderAccessorIsMarketplaceOrder,
} from '../../../../order'
import { orderQuestionSelfServiceAccessorGetReturnArticleUrl } from '../../../../order-question'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutReturnCta: FC<
  ContactPageSelfServiceShortcutProps
> = ({ availability }) => {
  const globalConfig = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  const isMarketplace =
    subOrder !== undefined && userSubOrderAccessorIsMarketplaceOrder(subOrder)

  const { data: miraklOrders, isLoading } = useApiOrdersSwrGetMiraklOrders({
    commercialOrderIds:
      isMarketplace && subOrder.subOrderId ? [subOrder.subOrderId] : [],
  })

  if (
    isLoading ||
    !subOrder?.subOrderId ||
    !lastOrder?.orderMasterData?.orderNumber
  ) {
    return null
  }

  if (availability === 'disabled') {
    return (
      <Button color="secondary" disabled size="small">
        <FormattedMessage id="contact.self.service.order.return.soon" />
      </Button>
    )
  }

  const isMiraklOrderReturnAvailable =
    miraklOrders?.some((miraklOrder) => miraklOrder.returnAvailable) ?? false

  return (
    <Button<'a'>
      color="secondary"
      href={orderQuestionSelfServiceAccessorGetReturnArticleUrl({
        config: globalConfig,
        isMiraklOrderReturnAvailable,
        orderId: lastOrder.orderMasterData.orderNumber,
        subOrder,
      })}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="contact.faqCardsSection.fifthCard.title" />
    </Button>
  )
}
